import dynamic from "next/dynamic";

const ProductCardActionNoSSr = dynamic(() => import("./ProductCardAction"), {
  ssr: false,
});

export default ProductCardActionNoSSr;
